module.exports = __webpack_public_path__ + "img/logo-white.92258340.png";